import { Component } from '@angular/core';

@Component({
  selector: 'ph-auth-flow-sdk-callback-component',
  template: '',
  standalone: false
})
export class SdkCallbackComponent {}
